<template>
  <div id="xmpChart" ref="xmpChart"></div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'xmpChart',
  props: {
    homeName: {
      type: String
    },
    awayName: {
      type: String
    },
    diff: {
      type: Object
    },
    homeTeamSide: {
      type: [Number, undefined]
    }
  },
  watch: {
    diff: function(n, o){
      this.$nextTick(() => {
        const chartDom = document.getElementById('xmpChart');
        if (chartDom) {
          this.initChart()
        }
      })
    }
  },
  methods: {
    initChart () {
      const _this = this
      const chartDom = document.getElementById('xmpChart');
      const myChart = echarts.init(chartDom);
      const x = JSON.parse(JSON.stringify(this.diff.x))
      const y = JSON.parse(JSON.stringify(this.diff.y))
      const homeName = String(_this.homeName)
      const awayName = String(_this.awayName)
      const isHomeRed = Number(this.homeTeamSide)
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: function(params){
            const hover = params[0]
            let name = hover.value < 0 ? awayName : homeName
            if (isHomeRed) {
              name = hover.value < 0 ? homeName : awayName
            }
            const y = (hover.value + '').replace('-', '')
            return `<div style="margin-left: 25px;">${hover.axisValue}min</div><div style="padding: 0 3px;">${name} 领先经验 <span style="color: #f9ae1f">${y}</span></div>`
          }
        },
        xAxis: {
          type: 'category',
          data: x,
          axisLabel: {
            formatter: (value, index) => {
              if (value === 0) {
                return 0
              }
              return value + 'min'
            }
          }
        },
        yAxis: {
          type: 'value',
          data: y,
          axisLabel: {
            formatter: (value, index) => {
              if (value > 0) {
                return value > 1000 ? (value / 1000).toFixed(1) + 'k' : value;
              } else {
                return value < -1000 ? (value / 1000).toFixed(1) + 'k' : value;
              }
            }
          }
        },
        series: [{
          data: y,
          type: 'line',
          smooth: 0.6,
          symbol: 'none',
          areaStyle: {
          }
        }],
        visualMap:[
          {
            type: 'piecewise',
            show: false,
            pieces: [{
              gt: -300000,
              lt: 0,
              color: '#ff3c2b'
            }, {
              gt: 0,
              lt: 300000,
              color: '#b3df57'
            }],
            outOfRange: {
              color: 'black'
            }
          }
        ],
        grid: {
          left: '50px',
          bottom: '50px',
          top: '50px',
          right: '50px'
        }
      });
    }
  },
  mounted () {
    this.$nextTick(() => {
      const chartDom = document.getElementById('xmpChart');
      if (chartDom) {
        this.initChart()
      }
    })
  }
}
</script>

<style lang="less" scoped>
#xmpChart {
  height: 470px;
}
</style>